import { render, staticRenderFns } from "./new-claim-ticket.vue?vue&type=template&id=17ee590a&scoped=true&"
import script from "./new-claim-ticket.vue?vue&type=script&lang=js&"
export * from "./new-claim-ticket.vue?vue&type=script&lang=js&"
import style0 from "./new-claim-ticket.vue?vue&type=style&index=0&id=17ee590a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ee590a",
  null
  
)

export default component.exports